// -- BI报表 report
import EmptyRouterAlive from '@/layout/EmptyRouterAlive.vue';
import EmptyRouter from '@/layout/EmptyRouter.vue';
// import Test0Empty from '@/views/test/empty.vue';

const NEW_PROFIT_ANALYSIS_NET_URL = 'https://bi-ap-southeast-1.quickbi.aliyun.com/dashboard/view/pc.htm?pageId=ab3a461d-d36f-4a39-a0bd-525e1f21b534&dd_orientation=auto';

function openExternalPage(url) {
  if (typeof window !== 'undefined' && url) {
    window.open(url, '_blank', 'noopener');
  }
}

export default {
  path: 'BIreport',
  name: 'BusinessBIReport',
  component: EmptyRouterAlive,
  meta: {
    title: 'BI报表',
  },
  children: [
    {
      path: 'profitAnalysis',
      name: 'BusinessBIReportCSGProfitAnalysisReport',
      component: EmptyRouter,
      redirect: 'profitAnalysis/profitAnalysis',
      meta: {
        title: 'Profit Analysis',
      },
      children: [
        {
          path: 'profitAnalysis',
          name: 'BusinessBIReportCSGProfitAnalysisReport',
          component: () => import('@/views/center-business/report/biReport'),
          meta: {
            title: 'Profit Analysis',
            isCache: true,
            iframeUrl: 'https://app.powerbi.com/reportEmbed?reportId=3853e55e-1d8b-4882-9ad4-e04754a411af&autoAuth=true&ctid=a4d3ab26-94d9-4ad7-b1f4-be569f4c7e7d&navContentPaneEnabled=false'
          },
          hidden: true,
        },
      ]
    },
    {
      path: 'profitAnalysisNet',
      name: 'BusinessBIReportTicketCompletionPerformanceReport',
      component: EmptyRouter,
      redirect: 'profitAnalysisNet/profitAnalysisNet',
      meta: {
        title: 'Profit Analysis - Net',
      },
      children: [
        {
          path: 'profitAnalysisNet',
          name: 'BusinessBIReportTicketCompletionPerformanceReport',
          component: () => import('@/views/center-business/report/biReport'),
          meta: {
            title: 'Profit Analysis - Net',
            isCache: true,
            iframeUrl: 'https://app.powerbi.com/reportEmbed?reportId=56f2d064-1147-47d8-acfc-96ed01283f63&autoAuth=true&ctid=a4d3ab26-94d9-4ad7-b1f4-be569f4c7e7d&navContentPaneEnabled=false'
          },
          hidden: true,
        },
      ]
    },
    {
      path: 'TicketPerformance',
      name: 'BusinessBIReportWarehousePerformanceReport',
      component: EmptyRouter,
      redirect: 'TicketPerformance/TicketPerformance',
      meta: {
        title: 'Ticket Performance',
      },
      children: [
        {
          path: 'TicketPerformance',
          name: 'BusinessBIReportWarehousePerformanceReport',
          component: () => import('@/views/center-business/report/biReport'),
          meta: {
            title: 'Ticket Performance',
            isCache: true,
            iframeUrl: 'https://app.powerbi.com/reportEmbed?reportId=3816e124-3a0d-4f07-a15b-1f9d2c8989da&autoAuth=true&ctid=a4d3ab26-94d9-4ad7-b1f4-be569f4c7e7d&navContentPaneEnabled=false'
          },
          hidden: true,
        },
      ]
    },
    {
      path: 'WarehousePerformance',
      name: 'BusinessBIReportProfitAnalysisReport',
      component: EmptyRouter,
      redirect: 'WarehousePerformance/WarehousePerformance',
      meta: {
        title: 'Warehouse Performance',
      },
      children: [
        {
          path: 'WarehousePerformance',
          name: 'BusinessBIReportProfitAnalysisReport',
          component: () => import('@/views/center-business/report/biReport'),
          meta: {
            title: 'Warehouse Performance',
            isCache: true,
            iframeUrl: 'https://app.powerbi.com/reportEmbed?reportId=e2892172-7aba-4017-a4a8-907955fd4f01&autoAuth=true&ctid=a4d3ab26-94d9-4ad7-b1f4-be569f4c7e7d&navContentPaneEnabled=false'
          },
          hidden: true,
        },
      ]
    },
    {
      path: 'newProfitAnalysisNet',
      name: 'BusinessBIReportNewCompletionPerformanceReport',
      component: EmptyRouter,
      beforeEnter(to, from, next) {
        openExternalPage(NEW_PROFIT_ANALYSIS_NET_URL);
        next(false);
      },
      meta: {
        title: 'New Profit Analysis - Net',
        externalUrl: NEW_PROFIT_ANALYSIS_NET_URL,
      },
    },
  ],
};
